<template>
  <BaseButton v-if="iconOnly">
    <i-heroicons-outline-pencil />
  </BaseButton>
  <BaseButton v-else class="pr-7">
    <div class="flex text-base">
      <i-heroicons-outline-pencil class="h-4 mx-2 mt-1 flex-grow" />
      <slot></slot>
    </div>
  </BaseButton>
</template>
<script>
export default {
  props: ["iconOnly"],
};
</script>
